import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import "../Styles/Home.css";
import logo from '../Images/Jayraj_logo.png';
import RightArrowIcon from '../Images/ArrowCircleRight.png';
import UserSection from '../Components/User_section.jsx';
import UserDestinations from '../Components/User_Destinations.jsx';
import Why_travel_with_us from '../Components/Why_travel_with_us.jsx';
import World_visiting_place from '../Components/World_visiting_place.jsx';
import Travelers_favorite from '../Components/Travelers_favorite.jsx';
import Navber from '../Components/Navber.jsx';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import api from "../Api.js";
import Travelers_fav_hotels from "../Components/Travelers_fav_hotel.jsx"
import Browse_by_catagory from "../Components/Browse_by_catagory.jsx"
import Testimonials from '../Components/Testimonials.jsx';
import HappyCustomersSlider from '../Components/HappyCustomersSlider.jsx';
import Typemsg from '../Components/Typemsg.jsx';
import Latest_tour_images from '../Components/Latest_tour_images.jsx';
import  Chatbot from '../Components/JayrajChatbot.jsx';



function Home() {
  const [menuOpen, setMenuOpen] = useState(false);
  const token = localStorage.getItem("accessToken");
  const navigate = useNavigate();
  const [faqdata, setFaqdata] = useState([]);
  const [loading, setLoading] = useState(true); // NEW
  const [slider, setSlider] = useState([]);




  const TITLE_ROUTE_MAP = {
    "group tour": "/tour/grouptour",
    "hotel": "/hotels",
    "activity": "/activities",
    "transport": "/transports",
  };

  const [index, setIndex] = useState(0);

  // Auto change every 4 seconds
  useEffect(() => {
    if (slider.length === 0) return;

    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slider.length);
    }, 10000);

    return () => clearInterval(timer);
  }, [slider.length]);

  useEffect(() => {
    if (slider.length > 0) {
      setIndex(0);
    }
  }, [slider]);




  useEffect(() => {
    const getSlider = async () => {
      try {
        const response = await api.get("/banners?type=web");
        console.log("Slider Response:", response.data);
        if (response?.data?.success === true) {
          const updatedData = response.data.data.map((item) => ({
            ...item,
            buttonLink: TITLE_ROUTE_MAP[item.topic] || "/",
          }));
          setSlider(updatedData);
        }
      } catch (err) {
        console.log(err);
      }
    }
    getSlider(); // ✅ CALL IT
  }, [])
  useEffect(() => {
    const fetchfaq = async () => {
      try {
        const response = await api.get("/faqs");
        if (response?.data?.status === true) {
          setFaqdata(response?.data?.data);
        }
      } catch (err) {
        console.log(err);
      } finally {
        // small delay so loader is visible
        setTimeout(() => setLoading(false), 1200);
      }
    };
    fetchfaq();
  }, []);
  const [expanded, setExpanded] = useState("panel0");

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  // Loader screen while loading
  if (loading) {
    return (
      <div className="jayraj-loader-overlay">
        <div className="jayraj-loader-wrapper">
          <img src={logo} alt="Logo" className="jayraj-loader-logo" />
          <div className="jayraj-loader-ring"></div>
        </div>
      </div>
    );
  }




  return (
    <>
    <Chatbot/>
      <Navber />
      <div className="hero">

        <div className="hero-slider">
          {slider.map((img, i) => (

            <img
              key={i}
              src={img.image}
              className={`hero-slide ${i === index ? "active" : ""}`}
            />


          ))}
        </div>
        {/* Desktop Slide Controls */}
        <div className="desktop-slide-btn left" onClick={() =>
          setIndex((prev) => (prev - 1 + slider.length) % slider.length)
        }>
          ❮
        </div>

        <div className="desktop-slide-btn right" onClick={() =>
          setIndex((prev) => (prev + 1) % slider.length)
        }>
          ❯
        </div>




        {/* Hero Content */}
        <div className='hero-content'>
          <div>
            <div className='big_text'>
              <span>
                {slider[index]?.title}
              </span>
              <strong className=' hero_big_text'>
                {slider[index]?.subtitle}
              </strong>
            </div>

            <p>{slider[index]?.description}</p>

            <button className="get-started" onClick={() => navigate(slider[index].buttonLink)}>
              <span>Get Started</span>
              <span style={{ display: "flex", alignItems: "center" }}>
                <img src={RightArrowIcon} alt='icon' width="25" height="25" />
              </span>
            </button>
          </div>

          {/* Circle Logo */}
          <div className="circle-text-container">
            <svg viewBox="0 0 200 200" className="circle-text">
              <defs>
                <path
                  id="circlePath"
                  d="
            M 100, 100
            m -75, 0
            a 75,75 0 1,1 150,0
            a 75,75 0 1,1 -150,0
          "
                />
              </defs>
              <text fill="white" fontSize="16" fontWeight="bold">
                <textPath href="#circlePath" startOffset="0%">
                  Curated Tours • Handpicked Hotels • Activities • Seamless Transport
                </textPath>
              </text>
            </svg>
            <img src={logo} alt="center logo" />
          </div>
        </div>






        {/* Hero Footer */}
        <div className="hero-footer" >
          <div className="social-icons">
            <a href="https://www.instagram.com/jayrajtours_group/"
              target="_blank"><i className="fab fa-instagram"></i></a>
            <a href="https://x.com/JayrajTourGroup"
              target="_blank"><i className="fab fa-twitter"></i></a>
            <a href="https://www.youtube.com/channel/UCBGOrdFLRH7jXePaKgDFJAA"
              target="_blank"><i className="fab fa-youtube"></i></a>
          </div>
          <div className="bottom-shape"></div>
        </div>
      </div>

      <UserSection />
      <hr style={{ padding: "0", margin: "0px" }} />
      {/* style={{ backgroundColor: "#e8dfd5" }} */}
      <div style={{ background: "linear-gradient(135deg, #f9fbff, #eef3ff)" }}>
        <UserDestinations />
        <Latest_tour_images/>
        <Browse_by_catagory />
        <Travelers_favorite />
        <Travelers_fav_hotels />
        <HappyCustomersSlider />
      </div>
      <div style={{ background: "linear-gradient(135deg, #f9fbff, #eef3ff)" }}>
        <Why_travel_with_us />
        <World_visiting_place />
      </div>

      <Typemsg />

      {/* <div className='contact_us'>
        <h2>Get exclusive travel tips and deals in your inbox</h2>
        <div className="message-box">
          <textarea placeholder="Type your message"></textarea>
          <button className="send-btn">
            Send Message <span>➜</span>
          </button>
        </div>
      </div> */}
      <div style={{
        width: "100%",
        fontFamily: "Quicksand, sans-serif",
        background: "linear-gradient(135deg, #f9fbff, #eef3ff)",
      }}>
        <div
          style={{

            maxWidth: "1200px",

            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            margin: "auto",
            // padding: "5%",
            borderRadius: "10px",
          }}
        >
          <h2 style={{ textAlign: "center", marginBottom: "2rem" }}>
            Frequently Asked <strong>Questions</strong>
          </h2>
          {faqdata?.map((faq, index) => (
            <Accordion
              key={faq?.id}
              expanded={expanded === `panel${index}`}
              onChange={handleChange(`panel${index}`)}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
              >
                <Typography component="span">
                  {faq?.question}
                </Typography>
              </AccordionSummary>

              <AccordionDetails>
                <Typography>{faq?.answer}</Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      </div>

      <Testimonials />
    </>
  );
}

export default Home;
